// extracted by mini-css-extract-plugin
module.exports = {"backIcon":"_8fVMz","shake":"_1tcl9"};